import { useEffect, useRef } from 'react';

interface UseListPagerOptions {
  incrementBy: number;
  initialValue: number;
  maxValue: number;
  callbackFn: (newValue: number) => void;
}

export const useListPager = (options: UseListPagerOptions) => {
  const { incrementBy, initialValue, maxValue, callbackFn } = options;
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const value = useRef(initialValue);

  useEffect(() => {
    const ref = loaderRef.current;
    if (ref) {
      const observer = new IntersectionObserver((entries) => {
        if (
          entries.some((entry) => entry.isIntersecting) &&
          value.current <= maxValue
        ) {
          value.current += incrementBy;
          callbackFn(value.current);
        }
      });

      observer.observe(ref);
      return () => {
        observer.unobserve(ref);
      };
    }
  }, [callbackFn, incrementBy, maxValue]);

  return {
    loaderRef,
  };
};
